export default __webpack_public_path__ + "static/media/medical.6555ad57.svg";